// Reconstructed from the supplied production build; original component names were unavailable.
import {
  CheckIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ClockIcon,
  CreditCardIcon,
  DollarSignIcon,
  DownloadIcon,
  FileTextIcon,
  PackageIcon,
  React,
  RefreshCwIcon,
  TrendingUpIcon,
  UserIcon,
  XIcon,
  motion,
  useNavigate,
  useParams,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
const AgentDetailsPage = () => {
  var B, K, Q, ne, L, ee, re, R, W, xe, ve;
  const { id: e } = useParams(),
    [t, n] = React.useState(null),
    [r, a] = React.useState(true),
    [l, c] = React.useState(null),
    [d, f] = React.useState(""),
    [h, p] = React.useState(""),
    [g, y] = React.useState(false),
    [v, j] = React.useState(false),
    [N, b] = React.useState(null),
    [S, O] = React.useState(1),
    [_, C] = React.useState(1),
    A = 10,
    T = useNavigate();
  React.useEffect(() => {
    M();
  }, [e]);
  const M = async () => {
      try {
        (a(true), c(null));
        const te = await api.get(`/admin/agents/${e}`);
        n(te.data);
      } catch (te) {
        (console.error("Error fetching agent details:", te),
          c("Failed to load agent details. Please try again later."));
      } finally {
        a(false);
      }
    },
    k = () => {
      (f(""), p(""), b(null), y(true));
    },
    $ = async () => {
      var ye, V;
      const te = parseFloat(d);
      if (isNaN(te) || te <= 0) {
        b("Please enter a valid amount");
        return;
      }
      if (te > t.wallet_balance) {
        b("Withdrawal amount cannot exceed wallet balance");
        return;
      }
      try {
        (j(true),
          b(null),
          await api.post(`/admin/agents/${e}/withdraw`, {
            amount: te,
            notes: h || "Administrative withdrawal",
          }),
          await M(),
          y(false));
      } catch (de) {
        (console.error("Error processing withdrawal:", de),
          b(
            ((V = (ye = de.response) == null ? undefined : ye.data) == null
              ? undefined
              : V.message) || "Failed to process withdrawal",
          ));
      } finally {
        j(false);
      }
    },
    I = () => {
      var V;
      if (!((V = t == null ? undefined : t.products) != null && V.length)) return [];
      const te = (S - 1) * A,
        ye = te + A;
      return t.products.slice(te, ye);
    },
    U = () => {
      var V;
      if (!((V = t == null ? undefined : t.transactions) != null && V.length)) return [];
      const te = (_ - 1) * A,
        ye = te + A;
      return t.transactions.slice(te, ye);
    },
    q =
      (B = t == null ? undefined : t.products) != null && B.length
        ? Math.ceil(t.products.length / A)
        : 0,
    z =
      (K = t == null ? undefined : t.transactions) != null && K.length
        ? Math.ceil(t.transactions.length / A)
        : 0,
    Y = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
        },
      },
    };
  if (r && !t)
    return (
      <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
          <div className={"flex items-center justify-center h-screen"}>
          <div className={"p-8 flex flex-col items-center"}>
            <div className={"w-16 h-16 relative"}>
              <div
                className={
                  "absolute inset-0 rounded-full border-t-4 border-b-4 border-purple-600 animate-spin"
                }
              />
              <div
                className={
                  "absolute inset-0 rounded-full border-r-4 border-l-4 border-purple-700 animate-pulse opacity-75"
                }
              />
            </div>
            <p className={"mt-4 text-gray-600"}>{"Loading agent details..."}</p>
          </div>
        </div>
      </div>
    );
  if (l && !t)
    return (
      <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
          <div className={"admin-main"}>
          <div className={"bg-white rounded-xl shadow-lg p-8 text-center"}>
            <div className={"mb-6"}>
              <div
                className={
                  "w-16 h-16 bg-red-100 rounded-full mx-auto flex items-center justify-center"
                }
              >
                <XIcon className={"h-8 w-8 text-red-600"} />
              </div>
            </div>
            <h2 className={"text-2xl font-bold text-gray-800 mb-2"}>{"Error Loading Agent"}</h2>
            <p className={"text-gray-600 mb-6"}>{l}</p>
            <div className={"flex justify-center space-x-4"}>
              <button
                onClick={() => T("/admin/agents")}
                className={
                  "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center"
                }
              >
                <ChevronLeftIcon className={"h-5 w-5 mr-2"} />
                {"Back to Agents"}
              </button>
              <button
                onClick={M}
                className={
                  "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                }
              >
                <RefreshCwIcon className={"h-5 w-5 mr-2"} />
                {"Retry"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  const F = ({ currentPage: te, totalPages: ye, setPage: V, entityName: de }) => {
    var oe, ce;
    return (
      <div
        className={
          "flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6 rounded-b-xl"
        }
      >
        <div className={"flex flex-1 justify-between sm:hidden"}>
          <button
            onClick={() => V(Math.max(1, te - 1))}
            disabled={te === 1}
            className={`relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 ${te === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50"}`}
          >
            {"Previous"}
          </button>
          <button
            onClick={() => V(Math.min(ye, te + 1))}
            disabled={te === ye || ye === 0}
            className={`relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 ${te === ye || ye === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50"}`}
          >
            {"Next"}
          </button>
        </div>
        <div className={"hidden sm:flex sm:flex-1 sm:items-center sm:justify-between"}>
          <div>
            <p className={"text-sm text-gray-700"}>
              {"Showing "}
              <span className={"font-medium"}>{ye === 0 ? 0 : (te - 1) * A + 1}</span>
              {" to"}{" "}
              <span className={"font-medium"}>
                {Math.min(
                  te * A,
                  ((oe = t == null ? undefined : t[de]) == null ? undefined : oe.length) || 0,
                )}
              </span>{" "}
              {"of "}
              <span className={"font-medium"}>
                {((ce = t == null ? undefined : t[de]) == null ? undefined : ce.length) || 0}
              </span>{" "}
              {de}
            </p>
          </div>
          <div>
            <nav
              className={"isolate inline-flex -space-x-px rounded-md shadow-sm"}
              aria-label={`${de} pagination`}
            >
              <button
                onClick={() => V(Math.max(1, te - 1))}
                disabled={te === 1}
                className={`relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 ${te === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50"}`}
              >
                <span className={"sr-only"}>{"Previous"}</span>
                <ChevronLeftIcon className={"h-5 w-5"} aria-hidden={"true"} />
              </button>
              {Array.from(
                {
                  length: ye,
                },
                ($e, Ae) => Ae + 1,
              ).map(($e) => (
                <button
                  key={$e}
                  onClick={() => V($e)}
                  className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${$e === te ? "bg-purple-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600" : "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0"}`}
                >
                  {$e}
                </button>
              ))}
              <button
                onClick={() => V(Math.min(ye, te + 1))}
                disabled={te === ye || ye === 0}
                className={`relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 ${te === ye || ye === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50"}`}
              >
                <span className={"sr-only"}>{"Next"}</span>
                <ChevronRightIcon className={"h-5 w-5"} aria-hidden={"true"} />
              </button>
            </nav>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
      <main className="admin-main">
        <motion.div initial={"hidden"} animate={"visible"} variants={Y} className={"mb-6"}>
          <button
            onClick={() => T("/admin/agents")}
            className={"flex items-center text-purple-600 hover:text-purple-800 transition-colors"}
          >
            <ChevronLeftIcon className={"h-5 w-5 mr-1"} />
            <span>{"Back to Agents"}</span>
          </button>
        </motion.div>
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={Y}
          className={"mb-8 bg-white rounded-2xl shadow-md p-6"}
        >
          <div className={"flex flex-col md:flex-row justify-between items-center"}>
            <div className={"flex items-center mb-4 md:mb-0"}>
              <div
                className={
                  "w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center text-purple-600"
                }
              >
                <UserIcon className={"h-8 w-8"} />
              </div>
              <div className={"ml-4"}>
                <h1 className={"text-2xl font-bold text-gray-900"}>
                  {(t == null ? undefined : t.name) || "Agent"}
                </h1>
                <p className={"text-gray-500"}>
                  {"ID: "}
                  {(t == null ? undefined : t.id) || "Unknown"}
                </p>
              </div>
            </div>
            <div className={"flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3"}>
              <button
                onClick={k}
                className={
                  "px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center justify-center"
                }
              >
                <DownloadIcon className={"h-5 w-5 mr-2"} />
                {"Process Withdrawal"}
              </button>
              <button
                onClick={M}
                className={
                  "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center justify-center"
                }
              >
                <RefreshCwIcon className={"h-5 w-5 mr-2"} />
                {"Refresh Data"}
              </button>
            </div>
          </div>
          <div className={"grid grid-cols-1 md:grid-cols-3 gap-4 mt-6"}>
            <div className={"bg-green-50 rounded-xl p-4"}>
              <div className={"flex items-center mb-2"}>
                <CreditCardIcon className={"h-5 w-5 text-green-600 mr-2"} />
                <span className={"text-sm font-medium text-green-600"}>{"Wallet Balance"}</span>
              </div>
              <div className={"text-2xl font-bold text-gray-800"}>
                {"₹"}
                {typeof (t == null ? undefined : t.wallet_balance) == "number" ||
                typeof (t == null ? undefined : t.wallet_balance) == "string"
                  ? parseFloat(t.wallet_balance).toFixed(2)
                  : "0.00"}
              </div>
            </div>
            <div className={"bg-purple-100 rounded-xl p-4"}>
              <div className={"flex items-center mb-2"}>
                <PackageIcon className={"h-5 w-5 text-purple-800 mr-2"} />
                <span className={"text-sm font-medium text-purple-800"}>{"Total Products"}</span>
              </div>
              <div className={"text-2xl font-bold text-gray-800"}>
                {((Q = t == null ? undefined : t.products) == null ? undefined : Q.length) || 0}
              </div>
            </div>
            <div className={"bg-amber-50 rounded-xl p-4"}>
              <div className={"flex items-center mb-2"}>
                <TrendingUpIcon className={"h-5 w-5 text-amber-600 mr-2"} />
                <span className={"text-sm font-medium text-amber-600"}>{"Total Sales"}</span>
              </div>
              <div className={"text-2xl font-bold text-gray-800"}>
                {"₹"}
                {typeof ((ne = t == null ? undefined : t.salesStats) == null
                  ? undefined
                  : ne.total_sales_amount) == "number" ||
                typeof ((L = t == null ? undefined : t.salesStats) == null
                  ? undefined
                  : L.total_sales_amount) == "string"
                  ? parseFloat(t.salesStats.total_sales_amount).toFixed(2)
                  : "0.00"}
                <span className={"text-sm text-gray-500 ml-2 font-normal"}>
                  {"("}
                  {((ee = t == null ? undefined : t.salesStats) == null
                    ? undefined
                    : ee.total_sales) || 0}{" "}
                  {((re = t == null ? undefined : t.salesStats) == null
                    ? undefined
                    : re.total_sales) === 1
                    ? "sale"
                    : "sales"}
                  {")"}
                </span>
              </div>
            </div>
          </div>
        </motion.div>
        <motion.div initial={"hidden"} animate={"visible"} variants={Y} className={"mb-8"}>
          <div className={"flex justify-between items-center mb-4"}>
            <h2 className={"text-xl font-bold text-gray-800 flex items-center"}>
              <PackageIcon className={"h-5 w-5 mr-2 text-purple-600"} />
              {"Products"}
            </h2>
          </div>
          {((R = t == null ? undefined : t.products) == null ? undefined : R.length) > 0 ? (
            <div className={"bg-white rounded-xl shadow-md overflow-hidden"}>
              <div className={"overflow-x-auto"}>
                <table className={"min-w-full divide-y divide-gray-200"}>
                  <thead>
                    <tr>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Title"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Category"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Created"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Price"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Actions"}
                      </th>
                    </tr>
                  </thead>
                  <tbody className={"bg-white divide-y divide-gray-200"}>
                    {I().map((te) => (
                      <tr
                        key={te.id || Math.random().toString()}
                        className={"hover:bg-gray-50 transition-colors"}
                      >
                        <td
                          className={
                            "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          }
                        >
                          {te.title || "Unnamed Product"}
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <span
                            className={
                              "px-2 py-1 text-xs rounded-full bg-purple-100 text-purple-800"
                            }
                          >
                            {te.category || "Uncategorized"}
                          </span>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap text-sm text-gray-500"}>
                          {te.created_at ? new Date(te.created_at).toLocaleDateString() : "N/A"}
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <span className={"text-sm font-medium text-gray-900"}>
                            {"₹"}
                            {typeof te.amount == "number" || typeof te.amount == "string"
                              ? parseFloat(te.amount).toFixed(2)
                              : "0.00"}
                          </span>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap text-sm text-gray-500"}>
                          <button
                            onClick={() => T(`/admin/products/${te.id}`)}
                            className={"text-purple-600 hover:text-purple-900 flex items-center"}
                          >
                            <FileTextIcon className={"h-4 w-4 mr-1"} />
                            {"Details"}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {((W = t == null ? undefined : t.products) == null ? undefined : W.length) > A && (
                <F currentPage={S} totalPages={q} setPage={O} entityName={"products"} />
              )}
            </div>
          ) : (
            <div className={"bg-white rounded-xl shadow-md p-8 text-center"}>
              <div className={"flex flex-col items-center"}>
                <div
                  className={
                    "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-gray-400 mb-4"
                  }
                >
                  <PackageIcon className={"h-8 w-8"} />
                </div>
                <h3 className={"text-lg font-medium text-gray-800 mb-2"}>{"No Products"}</h3>
                <p className={"text-gray-500"}>{"This agent hasn't uploaded any products yet."}</p>
              </div>
            </div>
          )}
        </motion.div>
        <motion.div initial={"hidden"} animate={"visible"} variants={Y}>
          <div className={"flex justify-between items-center mb-4"}>
            <h2 className={"text-xl font-bold text-gray-800 flex items-center"}>
              <CreditCardIcon className={"h-5 w-5 mr-2 text-purple-600"} />
              {"Transaction History"}
            </h2>
          </div>
          {((xe = t == null ? undefined : t.transactions) == null ? undefined : xe.length) > 0 ? (
            <div className={"bg-white rounded-xl shadow-md overflow-hidden"}>
              <div className={"overflow-x-auto"}>
                <table className={"min-w-full divide-y divide-gray-200"}>
                  <thead>
                    <tr>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Date"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Type"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Reference"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Amount"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Status"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Notes"}
                      </th>
                    </tr>
                  </thead>
                  <tbody className={"bg-white divide-y divide-gray-200"}>
                    {U().map((te) => (
                      <tr
                        key={te.id || Math.random().toString()}
                        className={"hover:bg-gray-50 transition-colors"}
                      >
                        <td className={"px-6 py-4 whitespace-nowrap text-sm text-gray-500"}>
                          {te.created_at ? new Date(te.created_at).toLocaleDateString() : "N/A"}
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          {te.transaction_type === "commission" ? (
                            <span
                              className={
                                "px-2 py-1 text-xs rounded-full bg-green-100 text-green-800 flex items-center w-fit"
                              }
                            >
                              <TrendingUpIcon className={"h-3 w-3 mr-1"} />
                              {"Commission"}
                            </span>
                          ) : te.transaction_type === "withdrawal" ? (
                            <span
                              className={
                                "px-2 py-1 text-xs rounded-full bg-red-100 text-red-800 flex items-center w-fit"
                              }
                            >
                              <DownloadIcon className={"h-3 w-3 mr-1"} />
                              {"Withdrawal"}
                            </span>
                          ) : (
                            <span
                              className={
                                "px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-800 flex items-center w-fit"
                              }
                            >
                              {te.transaction_type || "Other"}
                            </span>
                          )}
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap text-sm text-gray-500"}>
                          {te.reference_id || "N/A"}
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <span
                            className={`text-sm font-medium ${te.transaction_type === "commission" ? "text-green-600" : "text-red-600"}`}
                          >
                            {"₹"}
                            {typeof te.amount == "number" || typeof te.amount == "string"
                              ? parseFloat(te.amount).toFixed(2)
                              : "0.00"}
                          </span>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          {te.status === "completed" ? (
                            <span
                              className={
                                "px-2 py-1 text-xs rounded-full bg-green-100 text-green-800 flex items-center w-fit"
                              }
                            >
                              <CheckIcon className={"h-3 w-3 mr-1"} />
                              {"Completed"}
                            </span>
                          ) : te.status === "pending" ? (
                            <span
                              className={
                                "px-2 py-1 text-xs rounded-full bg-yellow-100 text-yellow-800 flex items-center w-fit"
                              }
                            >
                              <ClockIcon className={"h-3 w-3 mr-1"} />
                              {"Pending"}
                            </span>
                          ) : (
                            <span
                              className={
                                "px-2 py-1 text-xs rounded-full bg-red-100 text-red-800 flex items-center w-fit"
                              }
                            >
                              <XIcon className={"h-3 w-3 mr-1"} />
                              {te.status || "Failed"}
                            </span>
                          )}
                        </td>
                        <td className={"px-6 py-4 text-sm text-gray-500"}>
                          <div className={"max-w-xs truncate"}>{te.notes || "-"}</div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {((ve = t == null ? undefined : t.transactions) == null ? undefined : ve.length) >
                A && <F currentPage={_} totalPages={z} setPage={C} entityName={"transactions"} />}
            </div>
          ) : (
            <div className={"bg-white rounded-xl shadow-md p-8 text-center"}>
              <div className={"flex flex-col items-center"}>
                <div
                  className={
                    "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-gray-400 mb-4"
                  }
                >
                  <CreditCardIcon className={"h-8 w-8"} />
                </div>
                <h3 className={"text-lg font-medium text-gray-800 mb-2"}>{"No Transactions"}</h3>
                <p className={"text-gray-500"}>
                  {"This agent doesn't have any transaction history yet."}
                </p>
              </div>
            </div>
          )}
        </motion.div>
      </main>
      {g && (
        <div
          className={"fixed inset-0 bg-black/50 flex items-center justify-center z-50"}
        >
          <div className={"bg-white rounded-lg shadow-xl max-w-md w-full p-6"}>
            <h3 className={"text-lg font-bold text-gray-900 mb-4"}>{"Process Agent Withdrawal"}</h3>
            {N && (
              <div
                className={"mb-4 bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md"}
              >
                <p>{N}</p>
              </div>
            )}
            <div className={"mb-6"}>
              <div className={"flex justify-between items-center mb-4 bg-gray-50 p-3 rounded-lg"}>
                <span className={"text-sm text-gray-500"}>{"Agent"}</span>
                <span className={"font-medium"}>{t == null ? undefined : t.name}</span>
              </div>
              <div className={"flex justify-between items-center mb-4 bg-gray-50 p-3 rounded-lg"}>
                <span className={"text-sm text-gray-500"}>{"Current Balance"}</span>
                <span className={"font-medium text-green-600"}>
                  {"₹"}
                  {typeof (t == null ? undefined : t.wallet_balance) == "number" ||
                  typeof (t == null ? undefined : t.wallet_balance) == "string"
                    ? parseFloat(t.wallet_balance).toFixed(2)
                    : "0.00"}
                </span>
              </div>
              <div className={"mb-4"}>
                <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                  {"Withdrawal Amount"}
                </label>
                <div className={"relative"}>
                  <div
                    className={
                      "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    }
                  >
                    <DollarSignIcon className={"h-5 w-5 text-gray-400"} />
                  </div>
                  <input
                    type={"number"}
                    className={
                      "pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full"
                    }
                    placeholder={"0.00"}
                    value={d}
                    onChange={(te) => f(te.target.value)}
                    step={"0.01"}
                    min={"0.01"}
                    max={t == null ? undefined : t.wallet_balance}
                  />
                </div>
              </div>
              <div className={"mb-4"}>
                <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                  {"Notes (Optional)"}
                </label>
                <textarea
                  className={
                    "w-full border border-gray-300 rounded-lg p-2 focus:ring-purple-500 focus:border-purple-500"
                  }
                  rows={"3"}
                  value={h}
                  onChange={(te) => p(te.target.value)}
                  placeholder={"Add additional information about this withdrawal"}
                />
              </div>
            </div>
            <div className={"flex justify-end space-x-3"}>
              <button
                onClick={() => y(false)}
                className={
                  "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                }
              >
                {"Cancel"}
              </button>
              <button
                onClick={$}
                className={
                  "px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center"
                }
                disabled={v}
              >
                {v ? "Processing..." : "Process Withdrawal"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export { AgentDetailsPage };
